import { createContext } from 'react';

export const initialState = {
    employeeTitle: { title: 'Anställda', name: 'totalEmployees' },
    CoveringHeaderTitle: { title: 'Beläggningar' },
    willStartText: 'Inte Börjat',
    beginText: 'Börjar',
};

export const reducer = (state, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
